var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessStepNotStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 142,
    viewBox: "0 0 130 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_203_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0525 129.724C59.466 131.114 62.2036 131.846 64.9904 131.846C67.7772 131.846 70.5149 131.114 72.9284 129.724L112.062 107.194C114.475 105.804 116.479 103.806 117.873 101.398C119.266 98.9913 120 96.2608 120 93.4812L120 48.3641C120 45.5845 119.266 42.854 117.873 40.4469C116.479 38.0397 114.475 36.0408 112.062 34.6511L72.9284 12.1212C70.5149 10.7313 67.7772 9.99957 64.9904 9.99957C62.2036 9.99957 59.466 10.7313 57.0525 12.1212L17.938 34.6511C15.5247 36.0409 13.5207 38.0397 12.1273 40.4469C10.7339 42.854 10.0002 45.5845 9.99999 48.3641L10 93.4812C10.0002 96.2608 10.7339 98.9913 12.1273 101.398C13.5207 103.806 15.5247 105.804 17.938 107.194L57.0525 129.724Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_203_1557",
    x: 0,
    y: 0,
    width: 130,
    height: 141.846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_203_1557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_203_1557",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessStepNotStarted);
export default __webpack_public_path__ + "static/media/process_step_not_started.e7b42a5c6d77ad97ea709cf0d0a96410.svg";
export { ForwardRef as ReactComponent };